module.exports = __webpack_public_path__ + "img/coyi.12b5f072.jpg";